export default __webpack_public_path__ + "static/media/Tunic of the Faceless Chaos.32ef91d9.jpg";